var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.17606C16.0395 2.97294 15.464 3.63702 14.8884 4.16827C14.8884 4.30108 14.8884 4.4339 14.8884 4.69953C14.8884 5.76204 14.7733 6.82454 14.5431 7.75424C14.3129 8.81675 13.8525 9.74646 13.3921 10.6762C12.8166 11.6058 12.241 12.4028 11.5503 13.1997C10.7446 13.9965 9.82373 14.5277 8.90287 14.9262C7.8669 15.3247 6.71582 15.5903 5.56474 15.5903C3.72302 15.5903 1.9964 14.9262 0.5 13.8637C0.730215 13.8637 0.960432 13.8637 1.30575 13.8637C2.80216 13.8637 4.29856 13.3325 5.44963 12.2699C4.75899 12.2699 4.06834 12.0043 3.4928 11.473C2.91726 10.9418 2.57194 10.4105 2.34172 9.61364C2.57194 9.61364 2.80215 9.61364 2.91726 9.61364C3.26258 9.61364 3.49281 9.61364 3.83813 9.48083C3.14748 9.34801 2.45683 8.81676 1.9964 8.15268C1.30575 7.48862 1.07554 6.69174 1.07554 5.76203C1.53597 6.02766 2.11151 6.16047 2.57194 6.29329C2.11151 5.89485 1.76618 5.49641 1.42086 4.96515C1.19065 4.4339 0.96043 3.76982 0.96043 3.10575C0.96043 2.44169 1.07554 1.77761 1.42086 1.24636C2.22661 2.44169 3.26259 3.37138 4.41367 4.03545C5.56474 4.69953 6.83093 5.09796 8.21222 5.23078C8.21222 4.96515 8.09711 4.69953 8.09711 4.30108C8.09711 3.5042 8.32733 2.84012 8.67265 2.17606C9.01797 1.51199 9.59351 1.11355 10.169 0.715104C10.7446 0.449476 11.4352 0.316661 12.1259 0.58229C12.8165 0.715103 13.3921 1.11355 13.8525 1.64481C14.5431 1.51199 15.3489 1.24636 15.9244 0.715104C15.6942 1.64481 15.1187 2.30887 14.428 2.84012C15.2338 2.70732 15.9244 2.5745 16.5 2.17606Z",
    fill: "url(#paint0_linear_123_5698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_5698",
    x1: 0.5,
    y1: 8.07548,
    x2: 16.5,
    y2: 8.07548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7AC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.551c3374627d62ccf10d52bd538086f3.svg";
export { ForwardRef as ReactComponent };